import { Link } from "react-router-dom";

/**
 * Navbar logo using the official neuravolt Logo.svg.
 *
 * The SVG has a 375×375 viewBox but the actual logo content sits in a
 * narrow band: x≈8–368, y≈152–252 (≈360×100 px in SVG space).
 * We crop to that band via overflow:hidden + negative margin offsets.
 *
 * Maths (scale = targetH / svgContentH):
 *   targetH = 40px, svgContentH = 100, scale = 0.4
 *   fullImgH  = 375 × 0.4 = 150px
 *   marginTop = -(152 × 0.4) = -60.8px ≈ -61px
 *   cropW     = 360 × 0.4  = 144px
 *   cropH     = 100 × 0.4  = 40px
 *
 * `dark` = true  → invert colours so black text becomes white on dark hero
 * `dark` = false → natural rendering on the light scrolled navbar
 */
export const Logo = ({ dark = false, className = "" }) => {
  const baseFilter = dark
    ? "invert(1) hue-rotate(180deg) saturate(4.5) brightness(1.05)"
    : "none";

  const hoverFilter = dark
    ? "invert(1) hue-rotate(180deg) saturate(4.5) brightness(1.05) drop-shadow(0 0 10px rgba(255,90,31,0.75))"
    : "drop-shadow(0 0 10px rgba(255,90,31,0.55))";

  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`group flex items-center select-none ${className}`}
      style={{ textDecoration: "none" }}
    >
      {/* Crop window — only the logo band is visible */}
      <span
        style={{
          display: "inline-block",
          width: 148,      /* 360 × 0.4 + 4px padding */
          height: 42,      /* 100 × 0.4 + 2px padding */
          overflow: "hidden",
          position: "relative",
          flexShrink: 0,
          transition: "transform 0.35s cubic-bezier(.34,1.56,.64,1), filter 0.35s ease",
          willChange: "transform, filter",
          filter: baseFilter,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.07) translateY(-1.5px)";
          e.currentTarget.style.filter = hoverFilter;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1) translateY(0)";
          e.currentTarget.style.filter = baseFilter;
        }}
      >
        <img
          src="/neuravolt-logo.svg"
          alt="Neuravolt"
          draggable={false}
          style={{
            height: 150,          /* 375 × 0.4 */
            width:  150,          /* SVG is square */
            marginTop:  -61,      /* -(152 × 0.4) */
            marginLeft: -3,       /* -(8  × 0.4) */
            display: "block",
            flexShrink: 0,
            pointerEvents: "none",
            userSelect: "none",
          }}
        />
      </span>
    </Link>
  );
};

export default Logo;
